import { CardBackground } from "@hellocarbo/lasagne";
import { List, Root } from "@radix-ui/react-navigation-menu";
import { use } from "react";
import { useTranslation } from "react-i18next";

import { NavigationLink } from "@/components/Shared";
import { UserContext } from "@/contexts";

function Navigation() {
  const { t } = useTranslation(["dashboard"]);
  const { user } = use(UserContext);

  return (
    <CardBackground className="mb-sm">
      <Root orientation="horizontal">
        <List className="gap-x-sm flex">
          <NavigationLink href="/dashboard/multientity">
            {t("dashboard:page.multientity")}
          </NavigationLink>
          <NavigationLink href="/dashboard/overview">
            {t("dashboard:page.overview", { companyName: user?.company.name })}
          </NavigationLink>
        </List>
      </Root>
    </CardBackground>
  );
}

export default Navigation;
